import React from 'react';
import {SvgIcon} from '@fiverr/fit';
import PropTypes from 'prop-types';
import './style.scss';

const VOTES_THRESHOLD = 1000;
const FULL_STAR = 'full_star';
const EMPTY_STAR = 'o_star';
const HALF_STAR = 'o_half_star';

const Rating = ({ score, gigId, votes, starSize, starCount, isPro }) => {

    const getVotes = () => {
        if (votes >= VOTES_THRESHOLD) {
            return '1k+';
        }

        return votes;
    };

    const scoreText = (score / 2).toFixed(1),
        votesText = `(${getVotes()})`,
        starsScoreNum = Math.round(parseFloat(scoreText) * 2) / 2,
        starAttrs = {
            icon: FULL_STAR,
            color: 'yellow',
            width: starSize,
            height: starSize
        },
        stars = [],
        isNonRatedProSeller = score <= 0 && isPro,
        showScore = score > 0;

    for (let star = 1; star <= starCount; star++) {
        if (starCount > 1) {
            if (star <= starsScoreNum) {
                starAttrs.icon = FULL_STAR;
            } else if (star > Math.round(starsScoreNum)) {
                starAttrs.icon = EMPTY_STAR;
            } else {
                starAttrs.icon = HALF_STAR;
            }
        }

        starAttrs.key = `gig-rating-${gigId}`;

        stars.push(<SvgIcon {...starAttrs}/>);
    }

    return (
        <span className="gig-rating">
            {stars}
            {isNonRatedProSeller && <strong>{i18n.t('rating.be_the_first_to_rate')}</strong>}
            {showScore && <span><strong>{scoreText}</strong> {votesText}</span>}
        </span>
    );
};

Rating.propTypes = {
    score: PropTypes.number,
    votes: PropTypes.number
};

export default Rating;



// WEBPACK FOOTER //
// ./src/shared/rating/index.js